export default "__VITE_ASSET__14060ac6__"